import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { PeriodFilterValue } from '@/components/administration/commitment-matrix/commitment-matrix-period-filter'
import { defaultPeriodFilterValue } from '@/components/administration/commitment-matrix/commitment-matrix-period-filter'

export interface KpiMetricsFilterState {
	period: PeriodFilterValue
	weekOfYear: number | null
	year: number | null
	branchIds: string[]
	crIds: string[]
	jobGroupClusterId: string | null
	jobGroupId: string | null
	personName: string
	customerClassificationId: string | null
}

function defaultFilter(): KpiMetricsFilterState {
	return {
		period: defaultPeriodFilterValue(),
		weekOfYear: null,
		year: null,
		branchIds: [],
		crIds: [],
		jobGroupClusterId: null,
		jobGroupId: null,
		personName: '',
		customerClassificationId: null,
	}
}

interface KpiMetricsFilterStoreState {
	filter: KpiMetricsFilterState
	setFilter: (filter: KpiMetricsFilterState) => void
	resetFilter: () => void
}

export const useKpiMetricsFilterStore = create<KpiMetricsFilterStoreState>()(
	persist(
		(set) => ({
			filter: defaultFilter(),
			setFilter: (filter) => set({ filter }),
			resetFilter: () => set({ filter: defaultFilter() }),
		}),
		{
			name: 'ssma-kpi-metrics-filter',
			// Date não sobrevive ao JSON.stringify do persist — reidrata as
			// strings ISO de volta pra Date ao carregar do localStorage.
			merge: (persisted, current) => {
				const merged = { ...current, ...(persisted as object) }
				const persistedFilter = (
					persisted as { filter?: KpiMetricsFilterState }
				)?.filter
				if (persistedFilter?.period?.range) {
					merged.filter = {
						...current.filter,
						...persistedFilter,
						period: {
							...persistedFilter.period,
							range: {
								start: new Date(persistedFilter.period.range.start),
								end: new Date(persistedFilter.period.range.end),
							},
						},
					}
				}
				return merged
			},
		},
	),
)
